import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Avatar,
  Checkbox,
  FormControlLabel,
  Button,
  IconButton,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { fetchProgress ,uploadDocument , checkDocumentStatus, loadAdmissionFormDetail} from '../api'; 
import { ToastContainer, toast } from 'react-toastify';
import { FileUpload, Add, Undo } from '@mui/icons-material';


const ChildProgressAdmission = () => {

  
  const [motherCnicFile, setMotherCnicFile] = useState(null);
  const [fatherCnicFile, setFatherCnicFile] = useState(null);
  const [studentBFormFile, setStudentBFormFile] = useState(null);
  const [schoolRecords, setSchoolRecords] = useState([]);
  const [schoolLeavingCertificateFile, setSchoolLeavingCertificateFile] = useState(null);
  const [isSchoolLeavingApplicable, setIsSchoolLeavingApplicable] = useState(false);
  const [admissionStatus, setAdmissionStatus] = useState("unchecked");
  const [interviewDate, setInterviewDate] = useState(null);
  const [comments, setComments] = useState("");
  const { childId } = useParams();
  const location = useLocation();
  const child = location.state?.child;
  const handleFileChange = async (event, setter, documentType) => {
    const file = event.target.files[0];
    if (file && file.size <= 2 * 1024 * 1024) {
      try {
        await uploadDocument(childId, documentType, file);
        setter(file);
        toast.success('File uploaded successfully');
      } catch (error) {
        toast.error('Failed to upload the file');
      }
    } else {
      toast.error('File size should be 2MB or less');
    }
  };

  const handleAddSchoolRecord = () => {
    setSchoolRecords([...schoolRecords, null]);
  };

  const handleUndoSchoolRecord = (index) => {
    setSchoolRecords(schoolRecords.filter((_, i) => i !== index));
  };

  const handleSchoolRecordChange = (event, index) => {
    const file = event.target.files[0];
    if (file && file.size <= 2 * 1024 * 1024) {
      const updatedRecords = [...schoolRecords];
      updatedRecords[index] = file;
      setSchoolRecords(updatedRecords);
    } else {
      toast.error('File size should be 2MB or less');
    }
  };
  const [completedForms, setCompletedForms] = useState({
    code_of_conduct: false,
    medical_form: false,
    mvp4_form: false,
    mvp5_form: false,
    dp_subject_selection_form: false,
    language_survey_form: false,
    essay_short_response: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const loadProgress = async () => {
      try {
        const data = await fetchProgress(childId);
        setCompletedForms(data);
      } catch (error) {
        console.error('Failed to fetch progress:', error);
      }
    };
    const loadDocumentStatus = async () => {
      try {
        const status = await checkDocumentStatus(childId);
        setMotherCnicFile(status.parent_mother_cnic ? 'Uploaded' : null);
        setFatherCnicFile(status.parent_father_cnic ? 'Uploaded' : null);
        setStudentBFormFile(status.student_passport_bForm ? 'Uploaded' : null);
        setSchoolLeavingCertificateFile(status.school_transfer_certificate ? 'Uploaded' : null);
      } catch (error) {
        console.error('Failed to fetch document status:', error);
      }
    };
    const loadAdmissionFormDetails = async () => {
      try {
        const response = await loadAdmissionFormDetail(childId);
        setAdmissionStatus(response.status);
        setInterviewDate(response.interview_date);
        setComments(response.comments);
      } catch (error) {
        console.error('Failed to fetch admission form details:', error);
      }
    };


    loadProgress();
    loadDocumentStatus();
    loadAdmissionFormDetails();
    
  }, [childId]);

  const handleCheckboxChange = (formName) => {
    navigate(`/${formName}`, { state: { child } });
  };

  const showDPSubjectForm = child?.class_group_name.includes("DP");
  const showMYP5SubjectForm = child?.class_group_name.includes("MYP 5");
  const showMYP4SubjectForm = ["MYP 1", "MYP 2", "MYP 3", "MYP 4"].some(group => child?.class_group_name.includes(group));

  return (
    <Box className="home-page-container" sx={{ p: 4 }}>
      <Paper sx={{ p: 4, mb: 4 }}>
        <Typography variant="h3" className="home-heading" gutterBottom>
          Welcome to the Child Progress Admission
        </Typography>

        {admissionStatus !== "unchecked" && (
  <Paper sx={{ p: 4, mb: 4 }}>
    <Typography variant="h5" gutterBottom>
      Feedback
    </Typography>
    <Typography variant="body1">
      <strong>Admission Status:</strong> {admissionStatus || "N/A"}
    </Typography>
    <Typography variant="body1">
      <strong>Interview Date:</strong> {interviewDate ? new Date(interviewDate).toLocaleString() : "N/A"}
    </Typography>
    <Typography variant="body1">
      <strong>Comments:</strong> {comments || "No comments available"}
    </Typography>
  </Paper>
)}



        <Typography variant="body1" gutterBottom>
          Student data:
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {child?.picture && (
              <Avatar
                src={`http://34.67.251.33${child.picture}`}
                sx={{ width: 200, height: 150, mt: 2 }}
                variant="square"
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1"><strong>First Name:</strong> {child?.first_name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1"><strong>Last Name:</strong> {child?.last_name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1"><strong>Date of Birth:</strong> {child?.date_of_birth || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1"><strong>Email:</strong> {child?.email || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1"><strong>Gender:</strong> {child?.gender === 'M' ? 'Male' : child?.gender === 'F' ? 'Female' : 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1"><strong>Class Group:</strong> {child?.class_group_name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Present Address:</strong> {child?.present_address || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Permanent Address:</strong> {child?.permanent_address || 'N/A'}</Typography>
          </Grid>
        </Grid>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Required Documents:
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography variant="h6" align="start">
              Mother CNIC
            </Typography>
            <Button
              variant="contained"
              component="label"
              startIcon={<FileUpload />}
              disabled={!!motherCnicFile}
            >
              {motherCnicFile ? 'Uploaded' : 'Upload CNIC'}
              <input
                type="file"
                hidden
                onChange={(event) => handleFileChange(event, setMotherCnicFile, 'parent_mother_cnic')}
              />
            </Button>
            {motherCnicFile && <CheckCircleIcon style={{ color: 'green' }} />}
          </Grid>

          {/* Father CNIC Upload */}
          <Grid item xs={4}>
            <Typography variant="h6" align="start">
              Father CNIC
            </Typography>
            <Button
              variant="contained"
              component="label"
              startIcon={<FileUpload />}
              disabled={!!fatherCnicFile}
            >
              {fatherCnicFile ? 'Uploaded' : 'Upload CNIC'}
              <input
                type="file"
                hidden
                onChange={(event) => handleFileChange(event, setFatherCnicFile, 'parent_father_cnic')}
              />
            </Button>
            {fatherCnicFile && <CheckCircleIcon style={{ color: 'green' }} />}
          </Grid>

          {/* Student B-Form or Passport Upload */}
          <Grid item xs={4}>
            <Typography variant="h6" align="start">
              Student B-Form/Passport
            </Typography>
            <Button
              variant="contained"
              component="label"
              startIcon={<FileUpload />}
              disabled={!!studentBFormFile}
            >
              {studentBFormFile ? 'Uploaded' : 'Upload Document'}
              <input
                type="file"
                hidden
                onChange={(event) => handleFileChange(event, setStudentBFormFile, 'student_passport_bForm')}
              />
            </Button>
            {studentBFormFile && <CheckCircleIcon style={{ color: 'green' }} />}
          </Grid>

          {/* Dynamic Previous School Records Upload */}
          <Grid item xs={12}>
            <Typography variant="h6" align="start" gutterBottom>
              Previous School Records
            </Typography>
            {schoolRecords.map((file, index) => (
              <Grid container spacing={2} key={index} alignItems="center">
                <Grid item xs={8}>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<FileUpload />}
                    disabled={!!file} // Disable if file is uploaded
                  >
                    {file ? `Record ${index + 1} Uploaded` : `Upload Record ${index + 1}`}
                    <input
                      type="file"
                      hidden
                      onChange={(event) => handleSchoolRecordChange(event, index)}
                    />
                  </Button>
                  {file && <CheckCircleIcon style={{ color: 'green' }} />}
                </Grid>
                <Grid item xs={4}>
                  <IconButton
                    color="secondary"
                    onClick={() => handleUndoSchoolRecord(index)}
                  >
                    <Undo />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Button
              variant="outlined"
              startIcon={<Add />}
              onClick={handleAddSchoolRecord}
              sx={{ mt: 2 }}
            >
              Add Another Record
            </Button>
          </Grid>

          {/* School Leaving Certificate Upload */}
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isSchoolLeavingApplicable}
                  onChange={() => setIsSchoolLeavingApplicable(!isSchoolLeavingApplicable)}
                />
              }
              label="School Leaving Certificate Applicable?"
            />
            {isSchoolLeavingApplicable && (
              <Button
                variant="contained"
                component="label"
                startIcon={<FileUpload />}
                disabled={!!schoolLeavingCertificateFile}
              >
                Upload Certificate
                <input
                  type="file"
                  hidden
                  onChange={(event) => handleFileChange(event, setSchoolLeavingCertificateFile, 'school_transfer_certificate')}
                />
              </Button>
            )}
            {schoolLeavingCertificateFile && <CheckCircleIcon style={{ color: 'green' }} />}
          </Grid>
        </Grid>
     
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Required Forms:
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={completedForms.code_of_conduct}
                  onChange={() => handleCheckboxChange('code-of-conduct')}
                  color="primary"
                  icon={<CheckCircleIcon style={{ color: completedForms.code_of_conduct ? 'green' : 'inherit' }} />}
                  checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                  disabled={completedForms.code_of_conduct}
                />
              }
              label="Code of Conduct"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={completedForms.medical_form}
                  onChange={() => handleCheckboxChange('medical-form')}
                  color="primary"
                  icon={<CheckCircleIcon style={{ color: completedForms.medical_form ? 'green' : 'inherit' }} />}
                  checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                  disabled={completedForms.medical_form}
                />
              }
              label="Medical Form"
            />
          </Grid>
          {showDPSubjectForm && (
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={completedForms.dp_subject_selection_form}
                    onChange={() => handleCheckboxChange('dp-subject')}
                    color="primary"
                    icon={<CheckCircleIcon style={{ color: completedForms.dp_subject_selection_form ? 'green' : 'inherit' }} />}
                    checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                    disabled={completedForms.dp_subject_selection_form}
                  />
                }
                label="DP Subject Selection Form"
              />
            </Grid>
          )}
          {showMYP5SubjectForm && (
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={completedForms.myp5_form}
                    onChange={() => handleCheckboxChange('myp5-subject-selection-form')}
                    color="primary"
                    icon={<CheckCircleIcon style={{ color: completedForms.myp5_form ? 'green' : 'inherit' }} />}
                    checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                    disabled={completedForms.myp5_form}
                  />
                }
                label="MYP5 Subject Selection Form"
              />
            </Grid>
          )}
          {showMYP4SubjectForm && (
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={completedForms.myp4_form}
                    onChange={() => handleCheckboxChange('myp4-subject-selection-form')}
                    color="primary"
                    icon={<CheckCircleIcon style={{ color: completedForms.myp4_form ? 'green' : 'inherit' }} />}
                    checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                    disabled={completedForms.myp4_form}
                  />
                }
                label="MYP4 Subject Selection Form"
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={completedForms.language_survey}
                  onChange={() => handleCheckboxChange('language-survey-form')}
                  color="primary"
                  icon={<CheckCircleIcon style={{ color: completedForms.language_survey ? 'green' : 'inherit' }} />}
                  checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                  disabled={completedForms.language_survey}
                />
              }
              label="Language Survey Form"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={completedForms.essay_short_response}
                  onChange={() => handleCheckboxChange('essay-and-short-response-form')}
                  color="primary"
                  icon={<CheckCircleIcon style={{ color: completedForms.essay_short_response ? 'green' : 'inherit' }} />}
                  checkedIcon={<CheckCircleIcon style={{ color: 'green' }} />}
                  disabled={completedForms.essay_short_response}
                />
              }
              label="Essay and Short Response Form"
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
     
  );
};

export default ChildProgressAdmission;
